export default __webpack_public_path__ + "assets/images/85be281b62173aeee105c3fc11c19c1a.png";